import { getters } from '../store.js';

import { isWhatsAppMediaForTemplate } from '@/constants/whatsAppMimeTypes.js';

import { stringsMixin } from './StringsMixin';
import { variablesMixin } from './VariablesMixin';

export const whatsAppTemplateMixin = {
    mixins: [variablesMixin, stringsMixin],
    props: {
    },
    data: function() {
        return {}
    },
    computed: {
        currentEstablishment: function() {
            return getters.getCurrentEstablishment();
        },
        isUnsubmitted: function () {
            return this.isTemplateUnsubmitted(this.template);
        },
        isReceived: function () {
            return this.isTemplateReceived(this.template);
        },
        isPending: function () {
            return this.isTemplatePending(this.template);
        },
        isApproved: function () {
            return this.isTemplateApproved(this.template);
        },
        isRejected: function () {
            return this.isTemplateRejected(this.template);
        },
        isPaused: function () {
            return this.isTemplatePaused(this.template);
        },
        isDisabled: function () {
            return this.isTemplateDisabled(this.template);
        },
        statusForDisplay: function () {
            return this.templateStatusForDisplay(this.template);
        },
        hasActions: function() {
            return this.doesTemplateHaveActions(this.template);
        },
        hasMedia: function() {
            return this.doesTemplateHaveMedia(this.template);
        },
        hasImageMedia: function() {
            return this.doesTemplateHaveImageMedia(this.template);
        },
        hasVideoMedia: function() {
            return this.doesTemplateHaveVideoMedia(this.template);
        },
        hasAudioMedia: function() {
            return this.doesTemplateHaveAudioMedia(this.template);
        },
        hasPDFMedia: function() {
            return this.doesTemplateHavePDFMedia(this.template);
        },

    },
    methods: {
        isTemplateUnsubmitted: function (template) {
            return template.status === 'unsubmitted';
        },
        isTemplateReceived: function (template) {
            return template.status === 'received';
        },
        isTemplatePending: function (template) {
            return template.status === 'pending';
        },
        isTemplateApproved: function (template) {
            return template.status === 'approved';
        },
        isTemplateRejected: function (template) {
            return template.status === 'rejected';
        },
        isTemplatePaused: function (template) {
            return template.status === 'paused';
        },
        isTemplateDisabled: function (template) {
            return template.status === 'disabled';
        },
        templateStatusForDisplay: function(template) {
            switch (template.status) {
                case 'unsubmitted':
                    return '';
                case 'received':
                    return '<i class="fas fa-handshake"></i> Received';
                case 'pending':
                    return '<i class="fas fa-clock"></i> Reviewing';
                case 'approved':
                    return '<i class="fas fa-circle"></i> Approved';
                case 'rejected':
                    return '<i class="fas fa-exclamation-triangle"></i> Rejected';
                case 'paused':
                    return '<i class="fas fa-pause"></i> Paused';
                case 'disabled':
                    return '<i class="fas fa-exclamation-triangle"></i> Disabled';
                default:
                    return '';
            }
        },
        doesTemplateHaveActions: function(template) {
            return template.actions && template.actions.length > 0;
        },
        doesTemplateHaveMedia: function(template) {
            return (template.media && template.media.length > 0) || (template.mediaReferences && template.mediaReferences.length > 0);
        },
        doesTemplateHaveImageMedia: function(template) {
            return template.media && template.media.length > 0 && template.media.some(media => media.type.startsWith("image/"));
        },
        doesTemplateHaveVideoMedia: function(template) {
            return template.media && template.media.length > 0 && template.media.some(media => media.type.startsWith("video/"));
        },
        doesTemplateHaveAudioMedia: function(template) {
            return template.media && template.media.length > 0 && template.media.some(media => media.type.startsWith("audio/"));
        },
        doesTemplateHavePDFMedia: function(template) {
            return template.media && template.media.length > 0 && template.media.some(media => media.type.startsWith("application/pdf"));
        },
        previewTemplateContentHTML: function(template) {
            let previewText = template.content;

            // Replace smart quotes with straight quotes for better Markdown compatibility
            previewText = previewText.replace(/[“”]/g, '"');
            
            // Replace smart apostrophes with straight apostrophes for better Markdown compatibility
            previewText = previewText.replace(/[‘’]/g, "'");

            // WhatsApp bold *text* → Markdown bold **text**
            previewText = previewText.replace(/\*([^*\n]+)\*/g, '**$1**')

            // WhatsApp italic _text_ → Markdown italic *text*
            previewText = previewText.replace(/_([^_\n]+)_/g, '*$1*')

            // strike stays compatible
            previewText = previewText.replace(/~([^~\n]+)~/g, '~~$1~~');

            let variables = previewText.matchAll(/\${(.+?)}/g);
            if (variables) {
                for (let variable of variables) {
                    let value = this.getExampleForVariable(variable[1]);
                    previewText = previewText.replaceAll(variable[0], "<span class='template__preview-variable'>" + value + "</span>");
                }
            }
            return this.formatChatContentForDisplay(previewText);
        },
        attachFilesAsMediaOnTemplate: function(template) {
            if (this.doesTemplateHaveMedia(template)) {
                const media = this.currentEstablishment.preferences.files.filter(
                    file => isWhatsAppMediaForTemplate(file) && template.mediaReferences.some(reference => reference === file.reference)
                );
                this.$set(template, 'media', media);
            }
        }
    },
}